export default function ButtonLoader() {
    return (
        <>
            <span className="spinner-border spinner-border-sm ms-1" role="status" aria-hidden="true"></span>
            <span className="visually-hidden">Loading...</span>
        </>
    );
}